import '../firebase-config.js';
import '../firebase-sdk-bootstrap.js';
import '../firebase-storage-integration.js';
import '../error-logger.js';
import '../js/modules/monitoring.js';
import '../js/modules/notifications.js';
import '../js/modules/ui-performance.js';
import '../firebase-integration.js';
import '../firestore-realtime-sync.js';
import '../auth-service.js';
import '../firebase-oauth.js';
import '../js/app-entry.js';
import '../js/features/marketplace-stats.js';
import '../js/modules/socialUI.js';
import '../js/features/provider-favorites.js';
import '../functions/daily-close-core.js';
import '../js/features/provider-insights.js';
import '../js/features/provider-inventory.js';
import '../functions/ingredient-costing.js';
import '../app.js';
import '../renderAdminSubscriptions-extract.js';